// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-containers-PhotosDragAndDropApp-__PhotosDragAndDrop-module___wrapper","droppableEmailArea":"src-containers-PhotosDragAndDropApp-__PhotosDragAndDrop-module___droppableEmailArea","trash":"src-containers-PhotosDragAndDropApp-__PhotosDragAndDrop-module___trash","indicator":"src-containers-PhotosDragAndDropApp-__PhotosDragAndDrop-module___indicator"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/PhotosDragAndDropApp/PhotosDragAndDrop.module.css
// module id = 73
// module chunks = 0